import React, { useState, useEffect, useRef } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { ColorPicker } from 'primereact/colorpicker';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import { apiBase } from '../../../utils/config';
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import UploadFile from '../../UploadFile/UploadFile';

const AddEditFeeTemplate = (props) => {
    const { catchResponse } = useCatchResponse();
    const [securityUserID, setSecurityUserID] = useState("");
    const [templateName, setTemplateName] = useState('');
    const [templateNameErr, setTemplateNameErr] = useState(false);
    const [receiptTitle, setReceiptTitle] = useState('Fee Receipt');
    const [showSchoolLogo, setShowSchoolLogo] = useState(true);
    const [showSchoolName, setShowSchoolName] = useState(true);
    const [showSchoolAddress, setShowSchoolAddress] = useState(true);
    const [showStudentPhoto, setShowStudentPhoto] = useState(true);
    const [showRollNo, setShowRollNo] = useState(true);
    const [showGRNo, setShowGRNo] = useState(true);
    const [showFatherName, setShowFatherName] = useState(true);
    const [showClass, setShowClass] = useState(true);
    const [showBoard, setShowBoard] = useState(true);
    const [showPaymentMode, setShowPaymentMode] = useState(true);
    const [showCollectedBy, setShowCollectedBy] = useState(true);
    const [showSignature, setShowSignature] = useState(true);
    const [showRemarks, setShowRemarks] = useState(true);
    const [showContactNo, setShowContactNo] = useState(false);
    const [headerBGColor, setHeaderBGColor] = useState('1C515E');
    const [fontTheme, setFontTheme] = useState('Arial');

    // Image states
    const [signImage, setSignImage] = useState(null);
    const [signPreview, setSignPreview] = useState(null);
    const signImgRef = useRef(null);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props?.configId) {
            setTemplateName(props?.masterData?.TemplateName || '');
            setReceiptTitle(props?.masterData?.ReceiptTitle || 'Fee Receipt');
            setShowSchoolLogo(props?.masterData?.ShowSchoolLogo ?? true);
            setShowSchoolName(props?.masterData?.ShowSchoolName ?? true);
            setShowSchoolAddress(props?.masterData?.ShowSchoolAddress ?? true);
            setShowStudentPhoto(props?.masterData?.ShowStudentPhoto ?? true);
            setShowRollNo(props?.masterData?.ShowRollNo ?? true);
            setShowGRNo(props?.masterData?.ShowGRNo ?? true);
            setShowFatherName(props?.masterData?.ShowFatherName ?? true);
            setShowClass(props?.masterData?.ShowClass ?? true);
            setShowBoard(props?.masterData?.ShowBoard ?? true);
            setShowPaymentMode(props?.masterData?.ShowPaymentMode ?? true);
            setShowCollectedBy(props?.masterData?.ShowCollectedBy ?? true);
            setShowSignature(props?.masterData?.ShowSignature ?? true);
            setShowRemarks(props?.masterData?.ShowRemarks ?? true);
            setShowContactNo(props?.masterData?.ShowContactNo ?? false);
            setHeaderBGColor(props?.masterData?.HeaderBGColor?.replace('#', '') || '1C515E');
            setFontTheme(props?.masterData?.FontTheme || 'Arial');
            setSignImage(props?.masterData?.SignImage ? `${apiBase}/Upload/FeeTemplate/${props?.masterData?.SignImage}` : null);
        }
    }, []);

    const validate = () => {
        let isValid = true;
        if (CommonConfig.isEmpty(templateName)) {
            isValid = false;
            setTemplateNameErr(true);
        } else {
            setTemplateNameErr(false);
        }
        return isValid;
    };

    const onCancel = () => {
        props.onCancel();
    };

    const handleSignImage = (e) => {
        const file = e.files[0];
        if (file) {
            setSignImage(file);
            setSignPreview(URL.createObjectURL(file));
        }
    };

    const handleDelete = (label) => {
        if (label === 'Signature') {
            setSignImage(null);
            setSignPreview(null);
        }
    };

    const saveTemplate = async () => {
        if (!validate()) return;
        try {
            Loader.show();
            const formData = new FormData();
            if (props?.configId) formData.append('id', props.configId);
            formData.append('TemplateName', templateName);
            formData.append('ReceiptTitle', receiptTitle);
            formData.append('ShowSchoolLogo', showSchoolLogo);
            formData.append('ShowSchoolName', showSchoolName);
            formData.append('ShowSchoolAddress', showSchoolAddress);
            formData.append('ShowStudentPhoto', showStudentPhoto);
            formData.append('ShowRollNo', showRollNo);
            formData.append('ShowGRNo', showGRNo);
            formData.append('ShowFatherName', showFatherName);
            formData.append('ShowClass', showClass);
            formData.append('ShowBoard', showBoard);
            formData.append('ShowPaymentMode', showPaymentMode);
            formData.append('ShowCollectedBy', showCollectedBy);
            formData.append('ShowSignature', showSignature);
            formData.append('ShowRemarks', showRemarks);
            formData.append('ShowContactNo', showContactNo);
            formData.append('HeaderBGColor', `#${headerBGColor}`);
            formData.append('FontTheme', fontTheme);
            formData.append('CreatedBy', securityUserID);

            if (signImage && signImage.type) {
                formData.append('SignImage', signImage);
            } else if (CommonConfig.isEmpty(signImage)) {
                formData.append('SignImage', '');
            }

            await api.post(APIConstant.path.AddFeeTemplate, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            }).then(response => {
                if (response.success) {
                    Toast.success({ message: response.message });
                    Loader.hide();
                    onCancel();
                } else {
                    Toast.error({ message: response.message });
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            catchResponse(err);
        }
    };

    const fieldConfig = [
        { label: 'School Logo', value: showSchoolLogo, setter: setShowSchoolLogo },
        { label: 'School Name', value: showSchoolName, setter: setShowSchoolName },
        { label: 'School Address', value: showSchoolAddress, setter: setShowSchoolAddress },
        { label: 'Student Photo', value: showStudentPhoto, setter: setShowStudentPhoto },
        { label: 'Roll No', value: showRollNo, setter: setShowRollNo },
        { label: 'G.R. No', value: showGRNo, setter: setShowGRNo },
        { label: 'Father Name', value: showFatherName, setter: setShowFatherName },
        { label: 'Class', value: showClass, setter: setShowClass },
        { label: 'Board', value: showBoard, setter: setShowBoard },
        { label: 'Contact No', value: showContactNo, setter: setShowContactNo },
        { label: 'Payment Mode', value: showPaymentMode, setter: setShowPaymentMode },
        { label: 'Collected By', value: showCollectedBy, setter: setShowCollectedBy },
        { label: 'Signature', value: showSignature, setter: setShowSignature },
        { label: 'Remarks', value: showRemarks, setter: setShowRemarks },
    ];

    return (
        <div className="p-d-flex p-flex-column p-jc-between p-px-3">
            <div style={{ maxHeight: 'calc(100vh - 140px)', overflow: 'auto', overflowX: 'hidden' }}>
                <div className='p-grid'>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="templateName">Template Name *</label>
                            <InputText
                                className='p-w-100 p-mt-1'
                                id="templateName"
                                value={templateName}
                                maxLength={30}
                                onChange={(e) => setTemplateName(e.target.value)}
                            />
                        </div>
                        {templateNameErr && <span className="error-msg" style={{ color: 'red' }}>Template Name is required</span>}
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="receiptTitle">Receipt Title</label>
                            <InputText
                                className='p-w-100 p-mt-1'
                                id="receiptTitle"
                                value={receiptTitle}
                                maxLength={30}
                                onChange={(e) => setReceiptTitle(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label htmlFor="fontTheme">Font Theme</label>
                            <InputText
                                className='p-w-100 p-mt-1'
                                id="fontTheme"
                                value={fontTheme}
                                onChange={(e) => setFontTheme(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="custom-inputs">
                            <label>Header Background Color</label>
                            <div className="p-d-flex p-ai-center p-mt-1">
                                <ColorPicker value={headerBGColor} onChange={(e) => setHeaderBGColor(e.value)} />
                                <span className="p-ml-2">#{headerBGColor}</span>
                            </div>
                        </div>
                    </div>

                    {/* Signature Image Upload */}
                    <div className="p-col-12 p-md-4 p-pt-3" style={{ height: '220px' }}>
                        <UploadFile label='Signature' note='' preview={signPreview} original={signImage} uploadHandler={handleSignImage} uploadRef={signImgRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={null} />
                    </div>

                    <div className="p-col-12 p-pt-3">
                        <h4 style={{ marginBottom: '12px', color: '#1C515E' }}>Fields to Display on Receipt</h4>
                        <div className="p-grid">
                            {fieldConfig.map((field, index) => (
                                <div className="p-col-6 p-md-4 p-lg-3 p-py-2" key={index}>
                                    <Checkbox
                                        inputId={`field_${index}`}
                                        checked={field.value}
                                        onChange={(e) => field.setter(e.checked)}
                                    />
                                    <label htmlFor={`field_${index}`} className="p-ml-2">{field.label}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-py-2 p-px-5">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={onCancel} />
                <Button className='p-m-0 btn-text-action-primary submit-focus' label="Save" onClick={saveTemplate} />
            </div>
        </div>
    );
};

export default AddEditFeeTemplate;
